// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__pWMH4","container":"styles_container__YDpvK"};